<template>
  <Modal>
    <Modal.Title>Can't do this here</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Please go to your {{ store }} settings in order to resubscribe to your
        {{ planName }} plan.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleGoClick"
      >
        Go to {{ store }} settings
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import { useResubscribeIAP } from './useResubscribeIAP'

const { close } = useModal()
const { isMobile } = useDevice()
const { store, planName, handleGo } = useResubscribeIAP()

const handleGoClick = () => {
  close()
  handleGo()
}
</script>
